module.exports = "bubble-step-item {\n  display: block;\n  margin-bottom: 1rem; }\n"